<div fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>
  <h2 *ngIf="isUpdateMode()" class="headline m-0" fxFlex="auto">
    {{ 'EDIT_JOB_APPROVAL' | translate }}
  </h2>
  <h2 *ngIf="isCreateMode()" class="headline m-0" fxFlex="auto">
    {{ 'NEW_JOB_APPROVAL' | translate }}
  </h2>
  <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
    <mat-icon [icIcon]="icClose"></mat-icon>
  </button>
</div>
<mat-divider class="-mx-6 text-border"></mat-divider>
<mat-dialog-content fxLayout="column">
  <div class="container">
    <div id="content">
      <div @fadeInUp id="main-content">
        <mat-horizontal-stepper #horizontalStepper [linear]="true">
          <ng-template matStepperIcon="key">
            <mat-icon>vpn_key</mat-icon>
          </ng-template>
          <ng-template matStepperIcon="location">
            <mat-icon>location_on</mat-icon>
          </ng-template>
          <ng-template matStepperIcon="salary">
            <mat-icon> account_balance </mat-icon>
          </ng-template>
          <ng-template matStepperIcon="customfield">
            <mat-icon> support_agent </mat-icon>
          </ng-template>
          <ng-template matStepperIcon="users">
            <mat-icon> group </mat-icon>
          </ng-template>
          <ng-template matStepperIcon="preview">
            <mat-icon> preview </mat-icon>
          </ng-template>
          <ng-template matStepperIcon="edit">
            <mat-icon [icIcon]="icDoneAll"></mat-icon>
          </ng-template>
          <ng-template matStepperIcon="done">
            <mat-icon [icIcon]="icDoneAll"></mat-icon>
          </ng-template>
          <ng-template matStepperIcon="done">
            <mat-icon [icIcon]="icDoneAll"></mat-icon>
          </ng-template>

          <mat-step [stepControl]="keyFormGroup" label="Key" state="key">
            <div fxLayout="row">
              <ng-template matStepLabel fxlayoutAlign="center center"> </ng-template>
            </div>
            <form [formGroup]="keyFormGroup" autocomplete="off">
              <div fxLayout="row" fxlayoutAlign="center center">
                <h3>
                  <mat-icon>vpn_key</mat-icon> <span>{{ 'KEY' | translate }}</span>
                </h3>
              </div>

              <div
                *ngIf="isCreateMode()"
                class="mt-4"
                fxLayout="row"
                fxLayoutAlign="start center">
                <div class="w-full" fxLayout="column">
                  <mat-form-field class="flex-auto" appearance="outline">
                    <mat-label>{{ 'SELECT_TEMPLATE' | translate }}</mat-label>
                    <mat-select
                      (selectionChange)="getJobTemplate($event.value)"
                      disableOptionCentering
                      panelClass="mat-select-custom-panel">
                      <mat-option
                        [value]="item.JTemplateID"
                        *ngFor="let item of jobTemplateData">
                        {{ item.TemplateTitle }}
                      </mat-option>
                    </mat-select>
                    <mat-icon matPrefix>text_snippet</mat-icon>
                    <mat-hint>({{ 'SELECT_A_TEMPLATE' | translate }})</mat-hint>
                  </mat-form-field>
                </div>
              </div>

              <div *ngIf="!isCreateMode()" class="py-1"></div>

              <div class="mt-4" fxLayout="column" fxLayoutGap="8px">
                <mat-form-field fxFlex="auto" class="w-full">
                  <mat-label>{{ 'JOB_TITLE' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="jobTitle"
                    autocomplete="off"
                    [errorStateMatcher]="matcher"
                    required />
                  <mat-icon matPrefix>business_center</mat-icon>
                  <mat-error *ngIf="keyFormGroup.get('jobTitle').hasError('required')">
                    {{ 'JOB_TITLE_IS_REQUIRED' | translate }}.
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="example-chip-list">
                  <mat-label>{{ 'JOB_KEYWORD' | translate }}</mat-label>
                  <mat-chip-list #keywordChipList aria-label="Job Keyword selection">
                    <mat-chip
                      *ngFor="let item of keywords"
                      [selectable]="selectable"
                      [removable]="removable"
                      (removed)="removeKeyword(item)">
                      {{ item }}
                      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                    </mat-chip>
                    <input
                      #keywordInput
                      formControlName="jobKeyword"
                      [matAutocomplete]="autoKeyword"
                      [matChipInputFor]="keywordChipList"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      (matChipInputTokenEnd)="addKeyword($event)" />
                  </mat-chip-list>
                  <mat-autocomplete
                    #autoKeyword="matAutocomplete"
                    (optionSelected)="selectedKeyword($event)">
                    <ng-container *ngFor="let item of JKeywords | async">
                      <mat-option
                        *ngIf="!keywords.includes(item.HotbookName)"
                        [value]="item.HotbookName">
                        {{ item.HotbookName }}
                      </mat-option>
                    </ng-container>
                  </mat-autocomplete>
                  <mat-icon matPrefix>business_center</mat-icon>
                </mat-form-field>

                <div
                  fxLayout="row"
                  fxLayout.xs="column"
                  fxlayoutAlign="start start"
                  fxLayoutGap="20px">
                  <mat-form-field class="w-full" appearance="outline">
                    <mat-label>{{ 'BUSINESS_UNIT' | translate }}</mat-label>
                    <mat-select
                      (selectionChange)="getDepartmentData($event.value)"
                      formControlName="buisnessUnit"
                      disableOptionCentering
                      panelClass="mat-select-custom-panel"
                      [errorStateMatcher]="matcher"
                      required>
                      <mat-option
                        *ngFor="let item of buisnessUnitData"
                        [value]="item.id"
                        >{{ item.name }}</mat-option
                      >
                    </mat-select>
                    <mat-icon matPrefix>business</mat-icon>
                    <mat-error
                      *ngIf="keyFormGroup.get('buisnessUnit').hasError('required')">
                      {{ 'BUSINESS_UNIT_IS_REQUIRED' | translate }}.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field class="w-full" appearance="outline">
                    <mat-label>{{ 'DEPARTMENTS' | translate }}</mat-label>
                    <mat-select
                      formControlName="department"
                      disableOptionCentering
                      panelClass="mat-select-custom-panel"
                      [errorStateMatcher]="matcher"
                      required>
                      <mat-option
                        *ngFor="let item of departmentData"
                        [value]="item.deptid"
                        >{{ item.departmentName }}
                      </mat-option>
                    </mat-select>
                    <mat-icon matPrefix>business</mat-icon>
                    <mat-error
                      *ngIf="keyFormGroup.get('department').hasError('required')">
                      {{ 'DEPARTMENT_IS_REQUIRED' | translate }}.
                    </mat-error>
                  </mat-form-field>
                </div>

                <div
                  class="flex-auto html-editor mb-4 mt-3"
                  [ngClass]="{ hasErrorBorder: showJobDescriptionError }">
                  <p
                    class="ml-6 pt-4 subheading-2 font-medium"
                    [ngClass]="{ hasError: showJobDescriptionError }">
                    {{ 'JOB_DESCRIPTION' | translate }}
                    {{ 'AND' | translate }}
                    {{ 'REQUIRED_SKILL_EXPERIENCE' | translate }} *
                  </p>
                  <quill-editor
                    @fadeInUp
                    [styles]="{ flex: '1 1 auto', height: '280px' }"
                    formControlName="jobDescription"
                    required>
                  </quill-editor>
                </div>
                <mat-error *ngIf="showJobDescriptionError">
                  {{ 'JOB_DESCRIPTION_IS_REQUIRED' | translate }}.
                </mat-error>
                <!-- <div class="flex-auto html-editor mb-4 mt-3">
                  <p class="ml-6 pt-4 subheading-2 font-medium">
                    {{'REQUIRED_SKILL_EXPERIENCE' | translate}}
                  </p>
                  <quill-editor @fadeInUp [styles]="{ flex: '1 1 auto', height: '280px' }"
                    formControlName="requiredSkillExperience">
                  </quill-editor>
                </div> -->

                <div class="flex-auto html-editor mb-4 mt-3">
                  <p class="ml-6 pt-4 subheading-2 font-medium">
                    {{ 'JOB_BENEFITS_PER_DIEM_AND_COMPENSATION_PACKAGES' | translate }}
                  </p>
                  <quill-editor
                    @fadeInUp
                    [styles]="{ flex: '1 1 auto', height: '280px' }"
                    formControlName="jobBenefit">
                  </quill-editor>
                </div>
              </div>
            </form>
          </mat-step>

          <mat-step [stepControl]="locationFormGroup" label="Location" state="location">
            <div fxLayout="row">
              <ng-template matStepLabel fxlayoutAlign="center center"> </ng-template>
            </div>

            <form [formGroup]="locationFormGroup" autocomplete="off">
              <div fxLayout="row" fxlayoutAlign="center center">
                <h3><mat-icon>location_on</mat-icon> <span>Location</span></h3>
              </div>

              <div class="mt-4" fxLayout="column" fxLayoutGap="8px">
                <mat-form-field class="flex-auto w-full" appearance="outline">
                  <mat-label>{{ 'JOB_OWNER_ADMIN' | translate }}</mat-label>
                  <mat-select
                    formControlName="owner"
                    disableOptionCentering
                    panelClass="mat-select-custom-panel"
                    [errorStateMatcher]="matcher"
                    required>
                    <mat-option
                      *ngFor="let powerUser of AllPowerUsers"
                      [value]="powerUser.uid">
                      {{ powerUser.firstname + ' ' + powerUser.lastname }}
                    </mat-option>
                  </mat-select>
                  <mat-icon matPrefix>person</mat-icon>
                </mat-form-field>
                <mat-label (click)="toggleAddress()" class="cursor-pointer">{{
                  'COMPANY_ADDRESS' | translate
                }}</mat-label>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'CITY_TOWN' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="locationCity"
                    [errorStateMatcher]="matcher"
                    autocomplete="off"
                    required />
                  <mat-icon matPrefix>business_center</mat-icon>
                  <mat-error
                    *ngIf="locationFormGroup.get('locationCity').hasError('required')">
                    {{ 'CITY_TOWN_IS_REQUIRED' | translate }}.
                  </mat-error>
                </mat-form-field>
                <mat-form-field class="w-full" appearance="outline">
                  <mat-label>{{ 'COUNTRY' | translate }} *</mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="locationCountry"
                    [matAutocomplete]="autoCountry"
                    [errorStateMatcher]="matcher"
                    autocomplete="off" />
                  <mat-autocomplete
                    #autoCountry="matAutocomplete"
                    (optionSelected)="getStateByName($event)"
                    (closed)="onCountryOptionPanelClosed()">
                    <mat-option
                      *ngFor="let countrie of filteredCountriesData"
                      [value]="countrie.name">
                      {{ countrie.name }}
                      <div
                        *ngIf="countrie.iso == 'USA'"
                        style="background: lightgray; height: 2px"></div>
                    </mat-option>
                  </mat-autocomplete>
                  <mat-icon matPrefix>location_on</mat-icon>
                  <mat-error
                    *ngIf="locationFormGroup.get('locationCountry').hasError('required')">
                    {{ 'COUNTRY_IS_REQUIRED' | translate }}.
                  </mat-error>
                </mat-form-field>
                <mat-form-field class="w-full" appearance="outline">
                  <mat-label>{{ 'STATE' | translate }} *</mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="locationState"
                    [matAutocomplete]="autoState"
                    [errorStateMatcher]="matcher"
                    autocomplete="off" />
                  <mat-autocomplete
                    #autoState="matAutocomplete"
                    (closed)="onStateOptionPanelClosed()">
                    <mat-option
                      *ngFor="let state of filteredStateData"
                      [value]="state.name">
                      {{ state.name }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-icon matPrefix>location_on</mat-icon>
                  <mat-error
                    *ngIf="locationFormGroup.get('locationState').hasError('required')">
                    {{ 'STATE_IS_REQUIRED' | translate }}.
                  </mat-error>
                </mat-form-field>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'ZIP_POSTAL_CODE' | translate }}</mat-label>
                  <input
                    formControlName="locationZip"
                    [errorStateMatcher]="matcher"
                    autocomplete="off"
                    required
                    matInput />
                  <mat-icon matPrefix>business_center</mat-icon>
                  <mat-error
                    *ngIf="locationFormGroup.get('locationZip').hasError('required')">
                    {{ 'ZIP_POSTAL_CODE_IS_REQUIRED' | translate }}.
                  </mat-error>
                </mat-form-field>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'ADDITIONAL_LOCATION' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="locationAdditional"
                    autocomplete="off" />
                  <mat-icon matPrefix>business_center</mat-icon>
                </mat-form-field>
              </div>
            </form>
          </mat-step>

          <mat-step
            [stepControl]="salaryFormGroup"
            label="Salary"
            state="salary"
            optional="false">
            <div fxLayout="row">
              <ng-template matStepLabel fxlayoutAlign="center center"> </ng-template>
            </div>
            <form [formGroup]="salaryFormGroup" autocomplete="off">
              <div fxLayout="row" fxlayoutAlign="center center">
                <h3>
                  <mat-icon>account_balance</mat-icon>
                  <span>{{ 'SALARY' | translate }}</span>
                </h3>
              </div>

              <div class="mt-4" fxLayout="column" fxLayoutGap="8px">
                <mat-form-field class="w-full" appearance="outline">
                  <mat-label>{{ 'MIN' | translate }}</mat-label>
                  <input
                    type="text"
                    formControlName="salaryMin"
                    [errorStateMatcher]="matcher"
                    matInput
                    required />
                  <mat-icon matPrefix>meeting_room</mat-icon>
                  <mat-error
                    *ngIf="salaryFormGroup.get('salaryMin').hasError('required')">
                    {{ 'MIN_IS_REQUIRED_WITH_NUMBER_VALUE' | translate }}.
                  </mat-error>
                </mat-form-field>
                <mat-form-field class="w-full" appearance="outline">
                  <mat-label>{{ 'MAX' | translate }}</mat-label>
                  <input
                    formControlName="salaryMax"
                    [errorStateMatcher]="matcher"
                    matInput
                    required />
                  <mat-icon matPrefix>meeting_room</mat-icon>
                  <mat-error
                    *ngIf="salaryFormGroup.get('salaryMax').hasError('required')">
                    {{ 'MAX_IS_REQUIRED' | translate }}.
                  </mat-error>
                  <mat-error
                    *ngIf="salaryFormGroup.get('salaryMax').hasError('wrongSalary')">
                    {{ 'MAX_SHOULD_BE_BIGGER_THAN_MIN' | translate }}.
                  </mat-error>
                </mat-form-field>
              </div>
              <mat-form-field class="flex-auto w-full" appearance="outline">
                <mat-label>{{ 'CURRENCY' | translate }}</mat-label>
                <mat-select
                  formControlName="salCurrency"
                  disableOptionCentering
                  panelClass="mat-select-custom-panel"
                  [errorStateMatcher]="matcher"
                  required>
                  <mat-option
                    *ngFor="let item of jobCurrencyData"
                    [value]="item.CurrencyISO">
                    {{ item.CurrencyName }}</mat-option
                  >
                </mat-select>
                <mat-icon matPrefix>money</mat-icon>
                <mat-error
                  *ngIf="salaryFormGroup.get('salCurrency').hasError('required')">
                  {{ 'CURRENCY_IS_REQUIRED' | translate }}.
                </mat-error>
              </mat-form-field>
              <!-- <mat-label class="ml-4" style="color: gray;">Type</mat-label> -->
              <div
                class="flex-auto mt-4 mb-4"
                fxlayoutAlign="start start"
                fxLayout="row"
                fxLayout.xs="column"
                fxLayout.sm="column"
                fxLayoutGap="20px">
                <!-- <mat-radio-group formControlName="salType">
                  <mat-radio-button color="primary" class="mr-2" *ngFor="let item of salTypeData" [value]="item.RefValue">{{item.RefName}}</mat-radio-button>
                </mat-radio-group> -->
                <div
                  fxLayout="row"
                  fxLayoutAlign="space-around center"
                  class="w-full mb-2">
                  <mat-button-toggle-group
                    id="overall-rating"
                    class="w-full"
                    name="fontStyle"
                    aria-label="Font Style"
                    formControlName="salType">
                    <span
                      class="toggle-button w-full btn-border"
                      *ngFor="let item of salTypeData">
                      <mat-button-toggle
                        [value]="item.RefValue"
                        class="w-full"
                        fxLayoutAlign="center center">
                        <span class="toogle-text">{{ item.RefName }}</span>
                      </mat-button-toggle>
                    </span>
                  </mat-button-toggle-group>
                </div>
              </div>
            </form>
          </mat-step>

          <mat-step
            [stepControl]="customFormGroup"
            label="Custom Field"
            state="support_agent"
            optional="false">
            <div fxLayout="row">
              <ng-template matStepLabel fxlayoutAlign="center center"> </ng-template>
            </div>
            <form [formGroup]="customFormGroup" class="w-full" autocomplete="off">
              <div class="hire-custom-field" fxLayout="column" fxLayoutGap="8px">
                <div fxLayout="row" fxlayoutAlign="center center">
                  <h3>
                    <mat-icon>support_agent</mat-icon>
                    <span>{{ 'CUSTOM_FIELD' | translate }}</span>
                  </h3>
                </div>
                <div fxLayout="column" fxLayoutGap="8px">
                  <div class="flex-auto m-4" *ngIf="jobCustomFeildData.length == 0">
                    <h3>
                      {{ 'THERE_NO_CUSTOM_FIELD_NEED_TO_CREATE_TO_ADD_JOB' | translate }}.
                    </h3>
                    <h3>
                      {{
                        'YOU_CREATE_CUSTOM_FIELD_SETTING_RECRUITING_PREFERENCE_CUSTOM_FIELDS'
                          | translate
                      }}.
                    </h3>
                    <h3>{{ 'PLEASE_CLICK_BUTTON_BELOW' | translate }}.</h3>
                    <br />
                    <button
                      (click)="createCustomField()"
                      color="primary"
                      mat-raised-button>
                      {{ 'CREATE_NEW_CUSTOMFIELD' | translate }}
                    </button>
                  </div>
                </div>
                <div class="flex-auto mb-4">
                  <div *ngFor="let item of jobCustomFeildData; let i = index">
                    <div class="custom-field mb-3" *ngIf="item.customFieldType === 0">
                      <p class="mr-2">{{ item.customFieldName }}</p>
                      <mat-form-field class="w-full" appearance="outline">
                        <mat-label>{{ item.customFieldName }}</mat-label>
                        <input matInput [formControlName]="item.customFieldID" />
                      </mat-form-field>
                    </div>
                    <div class="custom-field mb-3" *ngIf="item.customFieldType === 1">
                      <p class="mr-2">{{ item.customFieldName }}</p>
                      <mat-form-field class="flex-auto w-full" appearance="outline">
                        <mat-label>{{ item.customFieldName }}</mat-label>
                        <mat-select
                          placeholder="-- Please Select One --"
                          [formControlName]="item.customFieldID">
                          <mat-option
                            *ngFor="let item of item.selectFromValue"
                            [value]="item">
                            {{ item }}</mat-option
                          >
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="mb-3" *ngIf="item.customFieldType === 2">
                      <ul>
                        <mat-label class="">{{ item.customFieldName }}</mat-label>
                        <li
                          class="w-full"
                          *ngFor="let subItem of item.selectFromValue; let i = index"
                          [formArrayName]="item.customFieldID">
                          <mat-checkbox color="primary" [formControlName]="i">
                            {{ subItem }}
                          </mat-checkbox>
                        </li>
                      </ul>
                    </div>
                    <div
                      fxLayout="row"
                      fxLayoutAlign="start center"
                      class="flex-auto w-full mb-3"
                      *ngIf="item.customFieldType === 3">
                      <p class="mr-2">{{ item.customFieldName }}</p>
                      <mat-radio-group
                        color="primary"
                        [formControlName]="item.customFieldID">
                        <mat-radio-button
                          *ngFor="let radioItem of item.selectFromValue"
                          value="{{ radioItem }}"
                          class="mr-4"
                          >{{ radioItem }}
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </mat-step>

          <mat-step
            [stepControl]="userFormGroup"
            label="Approvers"
            state="approvers"
            optional="false">
            <div fxLayout="row">
              <ng-template matStepLabel fxlayoutAlign="center center"> </ng-template>
            </div>

            <form [formGroup]="userFormGroup" autocomplete="off">
              <div fxLayout="row" fxlayoutAlign="center center">
                <h3>
                  <mat-icon>group</mat-icon> <span>{{ 'APPROVERS' | translate }}</span>
                </h3>
              </div>

              <div
                fxLayout="row"
                fxLayoutAlign="start center"
                class="flex-auto w-full my-3">
                <p class="mr-2">
                  <b>{{ 'DOES_THIS_JOB_NEED_APPROVAL' | translate }}</b>
                </p>
                <mat-radio-group
                  color="primary"
                  formControlName="needApproval"
                  (change)="onRequireApprovalChanged($event.value)">
                  <mat-radio-button value="Yes" class="mr-4"><b>Yes</b></mat-radio-button>
                  <mat-radio-button value="No" class="mr-4"><b>No</b></mat-radio-button>
                </mat-radio-group>
              </div>

              <ng-container formArrayName="users">
                <ng-container *ngFor="let userForm of users.controls; let i = index">
                  <mat-label
                    ><b>{{ i + 1 }}</b></mat-label
                  >
                  <div [formGroup]="userForm">
                    <mat-form-field class="w-full" appearance="outline">
                      <mat-select
                        formControlName="recruiter"
                        disableOptionCentering
                        panelClass="mat-select-custom-panel"
                        [errorStateMatcher]="matcher">
                        <mat-option
                          *ngFor="let recruiter of allRecruiters"
                          [value]="recruiter.recruiter_id">
                          {{ recruiter.Name }}</mat-option
                        >
                      </mat-select>
                      <mat-error *ngIf="userForm.get('recruiter').hasError('required')">
                        {{ 'RECRUITER_IS_REQUIRED' | translate }}.
                      </mat-error>
                    </mat-form-field>

                    <p
                      style="margin-top: -15px; margin-bottom: 5px"
                      fxLayoutAlign="center center"
                      class="w-full"
                      fxLayout="row"
                      fxLayoutGap="20px">
                      <mat-divider class="w-full"></mat-divider>
                      <b>OR</b>
                      <mat-divider class="w-full"></mat-divider>
                    </p>

                    <mat-label
                      >({{ 'FOR_MANUAL_INPUT_PLEASE_ENTER_BOTH' | translate }}
                      <b>{{ 'NAME' | translate }}</b> {{ 'AND' | translate }}
                      <b>{{ 'EMAIL' | translate }}</b
                      >)</mat-label
                    >
                    <div class="fxFlex w-full" fxLayout="row" fxLayoutGap="10px">
                      <mat-form-field fxFlex="40%" appearance="outline">
                        <mat-label>{{ 'NAME' | translate }}:</mat-label>
                        <input
                          formControlName="name"
                          [errorStateMatcher]="matcher"
                          matInput />
                        <mat-error *ngIf="userForm.get('name').hasError('required')">
                          {{ 'NAME_IS_REQUIRED' | translate }}.
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field fxFlex="40%" appearance="outline">
                        <mat-label>Email:</mat-label>
                        <input
                          formControlName="email"
                          [errorStateMatcher]="matcher"
                          matInput />
                        <mat-error *ngIf="userForm.get('email').hasError('required')">
                          {{ 'EMAIL_IS_REQUIRED' | translate }}.
                        </mat-error>
                        <mat-error *ngIf="userForm.get('email').hasError('pattern')">
                          {{ 'PLEASE_ENTER_A_VAILD_EMAIL_ADDRESS' | translate }}.
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field fxFlex="20%" appearance="outline">
                        <mat-label>{{ 'APPROVAL_LEVEL' | translate }}:</mat-label>
                        <input formControlName="approvalLevel" matInput />
                        <!-- <mat-select formControlName="approvalLevel">
                          <mat-option *ngFor="let item of approvalLevels" [value] = "item.value"> {{item.name}} </mat-option>
                        </mat-select> -->
                      </mat-form-field>
                    </div>
                  </div>

                  <mat-divider style="color: gray"></mat-divider>
                </ng-container>
              </ng-container>

              <div
                *ngIf="userFormGroup.value.needApproval === 'Yes'"
                class="w-full mt-4"
                fxLayoutAlign="center center">
                <button mat-mini-fab color="primary" (click)="addUser()">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </form>
          </mat-step>

          <!-- <mat-step [stepControl]="templateFormGroup" state="template">
            <div fxLayout="row">
              <ng-template matStepLabel fxlayoutAlign="center center">
                <div matTooltip="{{'TEMPLATE' | translate}}">&nbsp;&nbsp;&nbsp;</div>
              </ng-template>
            </div>

            <form [formGroup]="templateFormGroup">
              <div fxLayout="row" fxlayoutAlign="center center">
                <h3>
                  <mat-icon>text_snippet</mat-icon> <span>{{'SAVE_AS_TEMPLATE' | translate}}</span>
                </h3>
              </div>
              
              <mat-form-field class="flex-auto w-full" appearance="outline">
                <mat-label>Template Title</mat-label>
                <input formControlName="title" autocomplete="off" matInput>
              </mat-form-field>
            </form>
          </mat-step> -->
        </mat-horizontal-stepper>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    *ngIf="horizontalStepper.selectedIndex == 0"
    mat-button
    type="button"
    class="btn-close"
    (click)="horizontalStepper.reset()">
    {{ 'RESET' | translate }}
  </button>
  <button
    *ngIf="horizontalStepper.selectedIndex > 0"
    mat-button
    type="button"
    class="btn-close"
    (click)="horizontalStepper.previous()">
    {{ 'PREVIOUS' | translate }}
  </button>

  <button
    *ngIf="isCreateMode() && horizontalStepper.selectedIndex < 4"
    class="btn-action"
    (click)="next()"
    mat-button
    type="submit">
    {{ 'NEXT' | translate }}
  </button>
  <!-- [disabled]="!isApprovalValid()" -->
  <button
    *ngIf="isCreateMode() && horizontalStepper.selectedIndex == 4"
    class="btn-action"
    (click)="save()"
    mat-flat-button
    type="submit">
    {{ 'CREATE_JOB_APPROVAL' | translate }}
  </button>
  <button
    *ngIf="isUpdateMode() && horizontalStepper.selectedIndex < 4"
    class="btn-action"
    (click)="next()"
    mat-button
    type="submit">
    {{ 'NEXT' | translate }}
  </button>
  <!-- [disabled]="!isApprovalValid()" -->
  <button
    *ngIf="isUpdateMode() && horizontalStepper.selectedIndex == 4"
    class="btn-action"
    (click)="save()"
    mat-flat-button
    type="submit">
    {{ 'UPDATE_JOB_APPROVAL' | translate }}
  </button>
</mat-dialog-actions>
